/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-27 10:55:20
 * @LastEditors: linxi
 * @LastEditTime: 2021-06-17 15:30:44
 */
import React, { MouseEventHandler, ReactElement } from "react";
import styles from "./Icons.module.css";
import { ReactComponent as LogoIcon } from "./svg/logo.svg";
import { ReactComponent as DoctorIcon } from "./svg/doctor.svg";
import { ReactComponent as ErrorIcon } from "./svg/error.svg";
import { ReactComponent as HandleIcon } from "./svg/handle.svg";
import { ReactComponent as BehaviorIcon } from "./svg/behavior.svg";
import { ReactComponent as HomeOutlineIconAddIcon } from "./svg/add.svg";
import { ReactComponent as HomeOutlineIconSubtractIcon } from "./svg/jian.svg";

type IconMode = "large" | "normal" | "small" | "custom";

interface IconProps {
  mode?: IconMode;
  icon?: string;
  className?: string;
  onClick?: MouseEventHandler;
  style?: React.CSSProperties;
}

function getStyleName(props: IconProps): string {
  if (props.className && props.className !== "antd-menu-item-icon") {
    return props.className;
  }
  if (props.mode === "custom") {
    return styles.custom;
  }
  if (props.mode === "large") {
    return styles.large;
  }
  if (props.mode === "small") {
    return styles.smalll;
  }
  return styles.normal;
}

// export const Logo = (props: IconProps): ReactElement => (
//   <LogoIcon className={getStyleName(props)} style={props.style} />
// );

// export const Doctor = (props: IconProps): ReactElement => (
//   <DoctorIcon className={props.className} style={props.style} />
// );

// export const Error = (props: IconProps): ReactElement => (
//   <ErrorIcon className={getStyleName(props)} style={props.style} />
// );

// export const Handle = (props: IconProps): ReactElement => (
//   <HandleIcon className={getStyleName(props)} style={props.style} />
// );

// export const Behavior = (props: IconProps): ReactElement => (
//   <BehaviorIcon className={getStyleName(props)} style={props.style} />
// );

export const Icon = (props: IconProps): ReactElement => {
  switch (props.icon) {
    case "logo":
      return <LogoIcon className={getStyleName(props)} style={props.style} />;
    case "doctor":
      return <DoctorIcon className={props.className} style={props.style} />;
    case "handle":
      return <HandleIcon className={props.className} style={props.style} />;
    case "error":
      return <ErrorIcon className={props.className} style={props.style} />;
    case "behavior":
      return (
        <BehaviorIcon className={props.className} style={props.style} />
      );
    default:
      return <></>;
  }
};
export const WhiteListAddIcons = (props: IconProps): ReactElement => (
  <HomeOutlineIconAddIcon className={getStyleName(props)} style={props.style} />
);
export const WhiteListSubtractIcons = (props: IconProps): ReactElement => (
  <HomeOutlineIconSubtractIcon
    className={getStyleName(props)}
    style={props.style}
  />
);

export default Icon;
